export function SpecializedMedicalAttendances() {
	return <div>MedicalAttendancesByCidTable</div>;
}
